import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISOLUZIONE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIdOlRisoluzioneState extends EntityState<IID_OL_RISOLUZIONE, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_RISOLUZIONE })
export class IIDolRisoluzioneStore extends EntityStore<IIdOlRisoluzioneState> {
  constructor() {
    super([]);
  }
}
